import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import {MaintenanceModule} from "./modules/admin/pages/maintenance/maintenance.module";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'changepass', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule)},
            {path: 'confirmation-success', loadChildren: () => import('app/modules/auth/confirmation-success/confirmation-success.module').then(m => m.AuthConfirmationSuccessModule)},
            {path: 'newpass', loadChildren: () => import('app/modules/auth/new-password/new-password.module').then(m => m.AuthNewPasswordModule)}

        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)}
        ]
    },

    // Landing routes
    {
        path: '',
        component  : LayoutComponent,
        data: {
            layout: 'empty'
        },
        children   : [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
        ]
    },

    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        children   : [
            {path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/project/project.module').then(m => m.ProjectModule)},
            {path: 'users', loadChildren: () => import('app/modules/admin/users/users.module').then(m => m.UsersModule)},
            {path: 'profile', loadChildren: () => import('app/modules/admin/profile/profile.module').then(m => m.ProfileModule)},
            {path: 'credit', loadChildren: () => import('app/modules/admin/pages/credit/credit.module').then(m => m.CreditModule)},
            {path: 'support', loadChildren: () => import('app/modules/admin/pages/support/support.module').then(m => m.SupportModule)},
            {path: 'changelog', loadChildren: () => import('app/modules/admin/pages/changelog/changelog.module').then(m => m.ChangelogModule)},
            {path: 'settings', loadChildren: () => import('app/modules/admin/pages/settings/settings.module').then(m => m.SettingsModule)},
            {path: 'balance', loadChildren: () => import('app/modules/admin/balance/balance.module').then(m => m.BalanceModule)},
            {path: 'teams', loadChildren: () => import('app/modules/admin/teams/teams.module').then(m => m.TeamsModule)},
            {path: 'invoices', loadChildren: () => import('app/modules/admin/invoice/invoices.module').then(m => m.InvoicesModule)},
            {path: 'customers', loadChildren: () => import('app/modules/admin/customers/customers.module').then(m => m.CustomersModule)},
            {path: 'notifications', loadChildren: () => import('app/modules/admin/notifications/notifications.module').then(m => m.NotificationsModule)},
            {path: 'notification-types', loadChildren: () => import('app/modules/admin/notification-types/notification-types.module').then(m => m.NotificationTypesModule)},
            {path: 'notification-flow', loadChildren: () => import('app/modules/admin/notification-flow/notification-flow.module').then(m => m.NotificationFlowModule)},
            {path: 'invoicing', loadChildren: () => import('app/modules/admin/admin-invoicing/admin-invoicings.module').then(m => m.AdminInvoicingsModule)},
            {path: 'accesses', loadChildren: () => import('app/modules/admin/access/accesses.module').then(m => m.AccessesModule)},

            // maintenance, error & Catch all
            {path: 'maintenance', loadChildren: () => import('app/modules/admin/pages/maintenance/maintenance.module').then(m => m.MaintenanceModule)},
            {path: '500-internal-server-error', loadChildren: () => import('app/modules/admin/pages/error/error-500/error-500.module').then(m => m.Error500Module)},
            {path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/admin/pages/error/error-404/error-404.module').then(m => m.Error404Module)},
            {path: '**', redirectTo: '404-not-found'}
        ]
    }
];
